import React, { useState, useEffect } from 'react';
import './VasanthaVizha.css';
import { API_URL } from './config';

function VasanthaVizha() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/site-pages/vasantha_vizha`)
      .then(r => r.json())
      .then(d => {
        if (d.error) setError(d.error);
        else setPage(d);
      })
      .catch(() => setError('Network error.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="seasonal-page-disabled">Loading…</div>;
  if (error) return <div className="seasonal-page-disabled">{error}</div>;
  if (!page || !page.enabled) {
    return <div className="seasonal-page-disabled">This event isn't currently open. Check back later!</div>;
  }

  const c = page.content || {};

  return (
    <div className="vasantha-vizha-container">
      <h1 className="page-title">{c.event_name}</h1>

      <div className="event-details">
        <h2>Event Details</h2>
        <div className="details-grid">
          {c.date && (
            <div className="detail-item">
              <span className="detail-label">Date:</span>
              <span className="detail-value">{c.date}</span>
            </div>
          )}
          {c.time && (
            <div className="detail-item">
              <span className="detail-label">Time:</span>
              <span className="detail-value">{c.time}</span>
            </div>
          )}
          {c.venue && (
            <div className="detail-item">
              <span className="detail-label">Venue:</span>
              <span className="detail-value">{c.venue}</span>
            </div>
          )}
          {c.address && (
            <div className="detail-item">
              <span className="detail-label">Address:</span>
              <span className="detail-value">{c.address}</span>
            </div>
          )}
        </div>
      </div>

      <div className="registration-section">
        <h2>Registration Details</h2>

        {(c.registration_bullets || []).length > 0 && (
          <ul className="registration-checklist">
            {c.registration_bullets.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        )}

        {(c.important_instructions || c.important_note) && (
          <div className="important-note">
            <h3>Important Instructions</h3>
            {c.important_instructions && <p>{c.important_instructions}</p>}
            {c.important_note && <p><strong>Note:</strong> {c.important_note}</p>}
          </div>
        )}

        {c.registration_url && (
          <div className="registration-cta">
            <a
              href={c.registration_url}
              target="_blank"
              rel="noopener noreferrer"
              className="register-button"
            >
              {c.register_button_label || 'Register Now'}
            </a>
          </div>
        )}

        {(c.contact_name || c.contact_email) && (
          <div className="signature-section">
            <p className="signature">
              {c.contact_name && <><strong>{c.contact_name}</strong><br /></>}
              {c.contact_email && <a href={`mailto:${c.contact_email}`}>{c.contact_email}</a>}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default VasanthaVizha;
